<template>
        <div style="width: 100%">
        <v-progress-linear
            indeterminate
            :active="isLoading"
            style="width: 100%"
        ></v-progress-linear>
        <v-toolbar
            flat
            class="d-flex justify-center"
        >
            <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="prevMonth"
                :disabled="isLoading"
            >
                <v-icon small> mdi-chevron-left </v-icon>
            </v-btn>
            <v-toolbar-title
                class="font-weight-light primary--text"
            >
                Año
                {{ 
                    date.toLocaleDateString('es-ES', {
                        year: 'numeric',
                    })
                }}
            </v-toolbar-title>
            <v-btn
                fab
                text
                :small="$vuetify.breakpoint.smAndDown"
                color="grey darken-2"
                @click="nextMonth"
                :disabled="isLoading"
            >
                <v-icon small> mdi-chevron-right </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <div class="d-flex">
                <v-btn
                    outlined
                    class="mr-4"
                    color="success"
                    :small="$vuetify.breakpoint.smAndDown"
                    @click="openCreate()"
                    :disabled="isLoading"
                >
                    <v-icon :left="!$vuetify.breakpoint.smAndDown">
                        mdi-calendar
                    </v-icon>
                    {{
                        !$vuetify.breakpoint.smAndDown
                            ? 'Crear Festivo'
                            : ''
                    }}
                </v-btn>
            </div>
        </v-toolbar>

        <v-row class="ma-2">
            <v-col
                v-for="i in 12"
                :key="i"
                cols="12"
                md="3"
            >
                <v-card
                    elevation="0"
                    class="pa-4"
                    style="height: 100%"
                >
                    <div class="d-flex justify-center">
                        <h2 class="font-weight-light primary--text"> {{ getMonthName(i) }} </h2>
                    </div>
                    <div class="row-item mb-n6">
                        <div
                            v-for="day, j in ['L', 'M', 'X', 'J', 'V', 'S', 'D']"
                            :key="j"
                            cols="1"
                        >
                            <div
                                class="d-flex justify-center"
                                style="height: 40px"
                            >
                                <span class="font-weight-light">
                                    {{
                                        day
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row-item mt-4">
                        <div
                            class="item-round-circle"
                            v-for="day, j in getDaysInMonth(i)"
                            :key="j"
                            cols="1"
                        >
                            <div
                                class="d-flex justify-center"
                                style="height: 35px"
                            >
                                <v-tooltip bottom v-if="day.info">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-if="day.date.getMonth() === i - 1"
                                            class="font-weight-light festive"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="openDeleteDialog(day.info)"
                                        >
                                            {{
                                                day.date.toLocaleDateString('es-ES', {day: 'numeric',})
                                            }}
                                        </span>
                                    </template>
                                    <div class="pa-2">
                                        <div class="d-flex">
                                            <v-icon color="yellow" left>mdi-party-popper</v-icon>
                                            <h1 class="font-weight-light">{{day.info.name}}</h1>
                                            <v-icon color="yellow" right>mdi-party-popper</v-icon>
                                        </div>
                                        <p v-if="day.info.description" class="subtitle pt-4">{{day.info.description}}</p>
                                    </div>
                                </v-tooltip>
                                <span v-else>
                                    <span
                                        v-if="day.date.getMonth() === i - 1"
                                        :class="day.date.getDay() === 0 || day.date.getDay() === 6 ? 'font-weight-thin red--text' : 'font-weight-light'"
                                    >
                                        {{
                                            day.date.toLocaleDateString('es-ES', {day: 'numeric',})
                                        }}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <WorkingCalendarForm />
        <DeleteDialog />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { clone } from '@/util/libUtil.js';
import DeleteDialog from '@/components/DeleteDialog/DeleteDialog.vue';
import WorkingCalendarForm from './WorkingCalendarForm.vue';

export default {
    name: 'WorkingCalendarView',
    data: () => ({
        options: {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            timeZone: 'Europe/Madrid',
        },
        isLoading: false,
    }),
    components: {
        DeleteDialog,
        WorkingCalendarForm,
    },
    methods: {
        openCreate() {
            this.$store.commit('holidays/workingCalendarIsOpen', true);
        },
        prevMonth() {
            let newDate = this.date.setFullYear(this.date.getFullYear() - 1)
            this.$store.commit("holidays/workingCalendarDateFilter", new Date(newDate));
            this.$store.dispatch('holidays/fetchWorkingCalendar', {});
        },
        nextMonth() {
            let newDate = this.date.setFullYear(this.date.getFullYear() + 1)
            this.$store.commit("holidays/workingCalendarDateFilter", new Date(newDate));
            this.$store.dispatch('holidays/fetchWorkingCalendar', {});
        },
        getDaysInMonth(month) {
            let days = [];
            let date = new Date(this.date.getFullYear(), month - 1, 1);

            // Push the first day of the month
            let first = new Date(date)
            let info = this.isFestiveDay(new Date(date))
            if(info){
                days.push({date: first, info: info});
            } else {
                days.push({date: first});
            }

            while (date.getMonth() === month - 1) {
                date.setDate(date.getDate() + 1);

                info = this.isFestiveDay(new Date(date))
                if(info){
                    days.push({date: new Date(date), info: info});
                } else {
                    days.push({date: new Date(date)});
                }
            }

            let emptyDays = days[0].date.getDay();

            if (emptyDays === 0) emptyDays = 7;

            for (let i = 1; i < emptyDays; i++) {
                let prevDay = new Date(days[0]);
                prevDay.setDate(prevDay.getDate() - i);
                days.unshift({date: prevDay});
            }

            return days;
        },
        getMonthName(month) {
            let date = new Date(this.date.getFullYear(), month - 1, 1);
            let toLocale = date.toLocaleDateString('es-ES', {
                month: 'long',
            });

            return toLocale.charAt(0).toUpperCase() + toLocale.slice(1);
        },
        isFestiveDay(day) {
            day = new Date(day);
            day.setDate(day.getDate() + 1);

            return this.festiveDays.find(({date}) => {
                return date === day.toISOString().substr(0,10)
            });
        },
        openDeleteDialog({id}) {
            if(!this.hasAdminPermission) return;
            let deleteObj = {
                toDeleteId: id,
                toDeleteType: 'FESTIVE_DAY',
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
    },
    computed: {
        ...mapState('holidays', {
            date: (state) => state.workingCalendarObj.dateFilter,
            festiveDays: (state) => state.workingCalendarObj.workingCalendar,
        }),
        ...mapGetters('login', {
            hasAdminPermission: 'hasAdminPermission',
        }),
    },
};
</script>

<style scoped>
.row-item {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    padding: 10px;
}

.colored {
    background-color: #f5f5f5;
}

.festive {
    border-radius: 50%;
    position: absolute;
    width: 26px;
    text-align: center;
    background-color: #df5757;
    color: white;
    font-weight: 400 !important;
}


</style>